import { LiveAnnouncer } from '@angular/cdk/a11y';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, ElementRef, inject, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatChipInputEvent, MatChipGrid, MatChipRow, MatChipRemove, MatChipInput } from '@angular/material/chips';
import { MatDialog, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { map, Observable, startWith, Subject, takeUntil } from 'rxjs';
import { ApiResponse, CamDeleteModel } from 'src/app/models/interface/CAM/baseResponseInterfaces';
import { Branch, BusinessDetails, BusinessUnitRequest, } from 'src/app/models/interface/CAM/CompanyProfileInterface';
import { CamService } from 'src/app/services/camService/cam.service';
import { CryptoService } from 'src/app/services/commonService/crypto.service';
import { CompanyManagementService } from 'src/app/services/dataLayer/CAM/company-management.service';
import { CommonService } from 'src/app/shared/common/common.service';
import { ToastrApiService } from 'src/app/shared/common/toastr-api.service';
import { CompanyManagementContentService } from '../../services/company-management-content.service';
import { DisctionaryContent } from 'src/app/services/sitecoreDictionary/dictionary-content.service';
import { NgIf, NgFor, NgClass, AsyncPipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatLabel, MatError, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { MatAutocompleteTrigger, MatAutocomplete, MatOption } from '@angular/material/autocomplete';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatButton } from '@angular/material/button';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { CamEmptyStateComponent } from '../cam-empty-state/cam-empty-state.component';
import { CdkScrollable } from '@angular/cdk/scrolling';

@Component({
    selector: 'app-business-unit-overview',
    templateUrl: './business-unit-overview.component.html',
    styleUrls: ['./business-unit-overview.component.scss'],
    imports: [ReactiveFormsModule, NgIf, MatIcon, MatFormField, MatLabel, MatInput, MatError, MatSuffix, MatRadioGroup, MatRadioButton, MatChipGrid, NgFor, MatChipRow, MatChipRemove, MatChipInput, MatAutocompleteTrigger, MatAutocomplete, MatOption, MatCheckbox, MatButton, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, NgClass, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, CamEmptyStateComponent, CdkScrollable, MatDialogContent, MatDialogActions, AsyncPipe]
})
export class BusinessUnitOverviewComponent implements OnInit, OnDestroy {
  displayedColumns: string[] = ['Business Unit Name', 'Business Unit Code', 'Status', 'Actions'];
  Addnew: boolean = false;
  sauserId: string;
  businessUnitForm!: FormGroup;
  isLoading = true;
  selectedBranchIdsMap: { [key: number]: boolean } = {}; // Track selected branch IDs

  commonObjPipes: any = {
    GetAllDetails: { pipe: [] as BusinessDetails[], all: [] as BusinessDetails[] },
    GetAssociatedWithBranchId: { pipe: [] as Branch[], all: [] as Branch[] }
  }

  //open confirmation popup while delete
  @ViewChild('selectionWarning') selectionWarning!: TemplateRef<any>;
  currentItem: any;

  // chips dropdown variables
  separatorKeysCodes: number[] = [ENTER, COMMA];
  associatedWithBranchId = new FormControl('', Validators.required);
  filteredBranch: Observable<any[]>;
  BranchName: string[] = [];
  noRecordFound: boolean = false;

  @ViewChild('fruitInput') fruitInput!: ElementRef<HTMLInputElement>;

  announcer = inject(LiveAnnouncer);

  content:any;
  dictionaryContent:any;
  private readonly destroy$ = new Subject<void>();
  constructor(private readonly _CamService: CamService, private readonly fb: FormBuilder, private readonly crypto: CryptoService, private readonly dialog: MatDialog, private readonly _ToastrApiService: ToastrApiService, public _CommonService: CommonService, private readonly _CompanyManagementService: CompanyManagementService, private readonly contentService:CompanyManagementContentService,private readonly dictionaryContentService:DisctionaryContent) {

    this.sauserId = this.crypto.getValueFromKey('USERID') as string


    this.businessUnitForm = this.fb.group({
      flag: ["ADD"],
      businessUnitCode: ['', [Validators.required, Validators.maxLength(30)]],
      businessUnitName: ['', [Validators.required, Validators.maxLength(100), Validators.minLength(2)]],
      businessUnitHead: ['', [Validators.required, Validators.maxLength(100), Validators.minLength(2)]],
      businessUnitEmail: ['', [Validators.required,  Validators.pattern(
      /^[a-zA-Z0-9](?:[a-zA-Z0-9._!#$%&'*+/=?^`{|}~-]*[a-zA-Z0-9])?@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/
    ), Validators.minLength(5), Validators.maxLength(200)]],
      businessUnitContactNo: ['', [Validators.required, Validators.minLength(7), Validators.maxLength(15)]],
      businessUnitID: [null],
      associatedWithBranchId: ['', [Validators.required]],
      status: [true, [Validators.required]],
      sauserid: [this.sauserId]

    })

    this.filteredBranch = this.associatedWithBranchId.valueChanges.pipe(
      startWith(null),
      map((value: string | null) => {
        if (typeof value === 'string') {
          return this._filter(value);
        } else {
          return this.commonObjPipes.GetAssociatedWithBranchId.pipe.slice();
        }
      })
    );
  }

  ngOnInit(): void {
    this.contentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res:any)=>{
      this.content = res;
    });
    this.dictionaryContentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res:any)=>{
      this.dictionaryContent = res;
    });
    this.getBusinessUnitList()
    this.loadInitialData()

  }

  handleEvent(event: string) {
    if (event.includes('business-unit-overview')) {
      this._CompanyManagementService.company_management_businessUnit('Add Link','Add',this.commonObjPipes.GetAllDetails.pipe.length)//GTM use
      this.Addnew = true;
        this.businessUnitForm.reset({
           flag: "ADD",
           businessUnitCode: '',
           businessUnitName: '',
           businessUnitHead: '',
           businessUnitEmail: '',
           businessUnitContactNo: '',
           businessUnitID: null,
           associatedWithBranchId: '',
           status: true,
           sauserid: this.sauserId
    });

    this.businessUnitForm.markAsPristine();
    this.businessUnitForm.markAsUntouched();
    }
  }

  addNewBusinessUnit() {
    this.Addnew = true
    this.businessUnitForm.reset({
      flag: "ADD",
      businessUnitID: null,
      status: true,
      sauserid: this.sauserId
    })
    this.selectedBranchIdsMap = {};
    this.BranchName = [];

    this._CompanyManagementService.company_management_businessUnit('Add link','Add',this.commonObjPipes.GetAllDetails.pipe.length)//GTM use
  }


  async loadInitialData() {
    try {
      this.isLoading = true;

      const [branches] = await Promise.all([
        this._CamService.GetBranchInformation()
      ]);

      this.bindLists('GetAssociatedWithBranchId', branches.data);

    } catch (error) {
      console.error(error);
      this._ToastrApiService.show('error', 'Failed to load Business unit data.');
    } finally {
      this.isLoading = false;
    }
  }

  getBusinessUnitList() {
    this.isLoading = true
    this._CamService.getBusinessUnit().then((res: ApiResponse<BusinessDetails[]>) => {

      if (res.status == "Success") {
        this.bindLists('GetAllDetails', res.data)
      }
    }).catch((error) => {
      const errMsg = error?.message || error?.error?.message || 'Something went wrong while fetching Business Unit Overview List.';
      this._CompanyManagementService.view_error_message(errMsg,error?.code)
      this.bindLists('GetAllDetails', [])
      console.error(error)
    }).finally(() => {
      this.isLoading = false
    })

  }

  bindLists(key: string, lists: any[]) {
    this.commonObjPipes[key].pipe = lists;
    this.commonObjPipes[key].all = lists;
  }

  onCheckboxChange(event: any, branch: any, parentClass: string, matAutoClassRef: string) {

    this.selectedBranchIdsMap[branch.corpBranchId] = event.checked;

    if (event.checked) {
      if (!this.BranchName.includes(branch.corpBranchName)) {
        this.BranchName.push(branch.corpBranchName);
      }
    } else {
      this.BranchName = this.BranchName.filter(name => name != branch.corpBranchName);

    }

    const selectedBranchId = Object.keys(this.selectedBranchIdsMap)
      .filter(key => this.selectedBranchIdsMap[parseInt(key)])
      .map(key => parseInt(key));

    this.businessUnitForm.controls['associatedWithBranchId'].setValue(selectedBranchId.join(','));
    requestAnimationFrame(() => this.CustomMatAutoPosition(parentClass, matAutoClassRef));
  }

  CustomMatAutoPosition(parentClass: string, matAutoClassRef: string) {
    let parent = (document.querySelector(`.${parentClass}`) as HTMLDivElement).getBoundingClientRect();
    (document.querySelector('.cdk-overlay-connected-position-bounding-box .cdk-overlay-pane') as HTMLDivElement)?.style.setProperty('top', `${parent.top + parent.height}px`, 'important');
  }

  optionClicked(branch: any) {
    const newCheckedState = !this.selectedBranchIdsMap[branch.corpBranchId];

    const mockEvent = {
      checked: newCheckedState,
      stopPropagation: () => { } 
    };

    // Call your existing checkbox handler with the toggled state
    this.onCheckboxChange(mockEvent, branch, 'custom-businessUnit-mat-dropdown-parent', 'custom-autocomplete');
  };


  onSave() {
    this._CompanyManagementService.company_management_businessUnit('Save button','Save',this.commonObjPipes.GetAllDetails.pipe.length)//GTM use
    if (this.businessUnitForm.invalid) {
      return
    }

    const requestData: BusinessUnitRequest = {
      flag: this.businessUnitForm.value.flag,
      businessUnitCode: this.businessUnitForm.value.businessUnitCode,
      businessUnitName: this.businessUnitForm.value.businessUnitName,
      businessUnitHead: this.businessUnitForm.value.businessUnitHead,
      businessUnitEmail: this.businessUnitForm.value.businessUnitEmail,
      businessUnitContactNo: this.businessUnitForm.value.businessUnitContactNo,
      businessUnitID: this.businessUnitForm.value.businessUnitID,
      associatedWithBranchId: this.businessUnitForm.value.associatedWithBranchId,
      status: this.businessUnitForm.value.status,
      sauserid: this.businessUnitForm.value.sauserid
    }

    this._CamService.insertUpdateBusinessUnitV1(requestData).then((res) => {

      if (!res) {
        this._ToastrApiService.show('error', 'No response received from server.');
        return;
      }

      // Handle API response
      switch (res.status) {
        case 'Created':
          this._ToastrApiService.show('success', res.message || 'Business unit overview created successfully.');
          this._CompanyManagementService.save_success('Business unit overview', 'Success')//GTM use
          break;

        case 'Success':
          this._ToastrApiService.show('success', res.message || 'Business unit overview updated successfully.');
          this._CompanyManagementService.save_success('Business unit overview', 'Success')//GTM use
          break;

        case 'Conflict':
          this._ToastrApiService.show('warning', res.message || 'Duplicate entry detected.');
          break;

        default:
          this._ToastrApiService.show('error', res.message || 'Unexpected response from server.');
          break;
      }


      // Refresh list and reset form
      this.getBusinessUnitList();
      this.Addnew = false;
      this._CommonService.formResetTrigger();

    }).catch((error) => {
      console.error(error)
      const errorMessage =
        error?.error?.message ||
        error?.message ||
        'Something went wrong while saving the Business unit overview. Please try again later.';
      this._CompanyManagementService.view_error_message(errorMessage,error?.code);
      this._ToastrApiService.show('error', errorMessage)
    })

  }

  onCancel() {
    this.Addnew = false
    this._CompanyManagementService.company_management_businessUnit('Cancel button','Cancel',this.commonObjPipes.GetAllDetails.pipe.length)//GTM use

  }

  onEdit(item: BusinessDetails) {
    
    this._CompanyManagementService.company_management_businessUnit('Edit button','Edit',this.commonObjPipes.GetAllDetails.pipe.length)//GTM use

    this.Addnew = true;

    const associatedBranchIds = item.branchId
      ? item.branchId.split(',').map((id: string) => parseInt(id, 10))
      : [];

    this.businessUnitForm.patchValue({
      flag: "UPDATE",
      businessUnitCode: item.businessUnitCode,
      businessUnitName: item.businessUnitName,
      businessUnitHead: item.businessUnitHead,
      businessUnitEmail: item.businessUnitEmail,
      businessUnitContactNo: item.businessUnitContactNo,
      businessUnitID: item.businessUnitId,
      associatedWithBranchId: associatedBranchIds.join(','),
      status: item.status ? true : false,
      sauserid: this.sauserId

    })

    this.selectedBranchIdsMap = {};
    this.BranchName = [];

    associatedBranchIds.forEach((branchId: any) => {
      this.selectedBranchIdsMap[branchId] = true;
      const branch = this.commonObjPipes.GetAssociatedWithBranchId.pipe.find((b: { corpBranchId: any; }) => b.corpBranchId == branchId);
      if (branch) {
        this.BranchName.push(branch.corpBranchName);
      }
    });
  }

  onRemove(item: BusinessDetails) {
    this._CompanyManagementService.company_management_businessUnit('Remove button','Remove',this.commonObjPipes.GetAllDetails.pipe.length)//GTM use

    this.currentItem = item;
    const dialogRef = this.dialog.open(this.selectionWarning, {
      data: item, 
    });
  }

  confirmDelete(item: any) {

    const request: CamDeleteModel = {
      id: item.businessUnitId,
      type: 'BUSINESSUNIT'
    }

    this._CamService.DeleteCAMitemBytype(request).then((res) => {
      if (res.status == "Success") {
        this._ToastrApiService.show('success', res.message);
        this.currentItem = undefined;
        this.getBusinessUnitList()
        this._CompanyManagementService.businessUnit_remove_Successfully('Confirm','Success')//GTM use
      }
    }).catch((error) => {
      const errorMessage =
        error?.error?.message ||
        error?.message ||
        'Something went wrong while delete the Business unit. Please try again later.';
        this._CompanyManagementService.view_error_message(errorMessage,error?.code);
      this._ToastrApiService.show('error', errorMessage);
    })
  }

  CloseDialog(result: boolean) {
    if (result) {
      this.confirmDelete(this.currentItem)
      this._CompanyManagementService.businessUnit_remove('Proceed','Are you sure you want to remove this Business unit?')//GTM use
    }

    if(!result){
      this._CompanyManagementService.businessUnit_remove('Cancel','Are you sure you want to remove this Business unit?')//GTM use
    }

    this.dialog.closeAll(); 
  }

  disableRightClick(event: MouseEvent): void {
    event.preventDefault();
  }

  onPasteBlocked(event: ClipboardEvent): void {
    event.preventDefault(); 
  }

  blockInvalidCharacters1(event: KeyboardEvent): void {
    // List of invalid characters that can be used for XSS, SQL injection, or path traversal
    const invalidChars = ['<', '>', '"', "'", '`', ';', ':', '$', '|', '[', ']', '~', '--', '@', '\\', '?', '+', '_', '#', '%', '^', '*', '!', '=', '%', '(', ')', '{', '}',];

    // If the pressed key is in the invalidChars array, prevent the input
    if (invalidChars.includes(event.key)) {
      event.preventDefault(); // Block the invalid character
    }
  }

  blockInvalidCharacters(event: KeyboardEvent): void {
    // List of invalid characters that can be used for XSS, SQL injection, or path traversal
    const invalidChars = ['<', '>', '"', "'", '`', ';', '--', '\\', '?', '+', '_', '#', '%', '^', '*', '!', '=', '%', '(', ')', '{', '}',];

    // If the pressed key is in the invalidChars array, prevent the input
    if (invalidChars.includes(event.key)) {
      event.preventDefault(); // Block the invalid character
    }
  }

    blockInvalidCharactersForEmail(event: KeyboardEvent): void {
    // List of invalid characters that can be used for XSS, SQL injection, or path traversal
    const invalidChars = ['<', '>', '"', "'", '`', ';', '--', '\\', '?', '+', '#', '%', '^', '*', '!', '=', '%', '(', ')', '{', '}',];

    // If the pressed key is in the invalidChars array, prevent the input
    if (invalidChars.includes(event.key)) {
      event.preventDefault(); 
    }
  }
  // Block non-numeric input
  allowedNumberOnly(event: KeyboardEvent) {
    const charCode = event.key.charCodeAt(0);
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }

  //chips dropdown methods
  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    // Add our fruit
    if (value) {
      const matchingBranch = this.commonObjPipes.GetAssociatedWithBranchId.pipe.find((b: { Name: String }) => b.Name.toLowerCase().trim() == value.toLowerCase().trim())
      if (matchingBranch) {
        this.onCheckboxChange({ checked: true, stopPropagation: () => { } }, matchingBranch, 'custom-mat-dropdown-parent', 'custom-autocomplete');
      }
    }

    // Clear the input value
    event.chipInput!.clear();

    this.associatedWithBranchId.setValue(null);
    let parent = (document.querySelector(`.${'custom-businessUnit-mat-dropdown-parent'}`) as HTMLDivElement).getBoundingClientRect();
    (document.querySelector(`.${'custom-autocomplete'}`) as HTMLDivElement).style.marginTop = `${parent.top + parent.height}px`;

  }

  remove(name: string): void {

    const index = this.BranchName.indexOf(name);

    if (index >= 0) {
      this.BranchName.splice(index, 1);
      this.announcer.announce(`Removed ${name}`);

      const branch = this.commonObjPipes.GetAssociatedWithBranchId.pipe.find((b: { corpBranchName: string; }) => b.corpBranchName == name)

      if (branch) {
        this.selectedBranchIdsMap[branch.corpBranchId] = false;

        const selectedBranchId = Object.keys(this.selectedBranchIdsMap)
          .filter(key => this.selectedBranchIdsMap[parseInt(key)])
          .map(key => parseInt(key));
        this.businessUnitForm.controls['associatedWithBranchId'].setValue(selectedBranchId.join(','))
        this.businessUnitForm.controls['associatedWithBranchId'].updateValueAndValidity();
      }
    }
  }


  private _filter(value: string): any[] {
    const filterValue = value.toLowerCase();
    const filteredData = this.commonObjPipes.GetAssociatedWithBranchId.pipe.filter((branch: { corpBranchName: string; }) => branch.corpBranchName.toLowerCase().includes(filterValue));
    this.noRecordFound = filteredData.length == 0;
    return filteredData
  }
  
  sitecoreGetWarningMessage(messageId: string): any {
    return this.content?.warningList?.find(
      (item: any) => item.messageID === messageId
    );
  }

ngOnDestroy(){
  this.destroy$.next();
  this.destroy$.complete();
}
}
